import { Typography } from 'ui';

import { getCreateSiteMaterialUrl } from '../../utils/getCreateSiteMaterialUrl';

type Props = {
  tradeCompanyId?: number;
};

export const NoSiteMaterialsOption = ({ tradeCompanyId }: Props) => {
  if (tradeCompanyId) {
    return (
      <Typography>
        No site material found -{' '}
        <a target="_blank" href={getCreateSiteMaterialUrl(tradeCompanyId)} rel="noreferrer">
          create a site material
        </a>
      </Typography>
    );
  }
  return <Typography>No site material found</Typography>;
};
